module.exports = __webpack_public_path__ + "static/clubs-home-e17428fab81dcacf0885939a61f1e45a.svg";